<template>
  <w-icon-wrapper
    :width='19.2'
    :height='24'
    icon-name='work-nav-activities-icon'
    view-box='0 0 19.2 24'
  >
    <path
      id="_14_Aktivitäten_Icon"
      data-name="14_Aktivitäten_Icon"
      d="M168.34-860.8l6.78-6.78-1.74-1.74-5.07,5.07-2.52-2.52-1.71,1.71ZM162.4-856a2.311,2.311,0,0,1-1.695-.7,2.311,2.311,0,0,1-.705-1.7v-19.2a2.311,2.311,0,0,1,.705-1.7A2.311,2.311,0,0,1,162.4-880H172l7.2,7.2v14.4a2.311,2.311,0,0,1-.705,1.7,2.311,2.311,0,0,1-1.695.7Zm8.4-15.6v-6h-8.4v19.2h14.4v-13.2Zm-8.4-6v0Z"
      transform="translate(-160 880)"
      fill="currentColor"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconNavActivities' };
</script>

